import React, { useContext, useState, useCallback, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { storage } from "../../firebase";
import { Context as KitContext } from "../../context/KitContext";

import { Button } from "primereact/button";
import { Galleria } from "primereact/galleria";
import { Dialog } from "primereact/dialog";

import Cropper from "react-easy-crop";
import Resizer from "react-image-file-resizer";
import mergeImages from "merge-images";

import getCroppedImg from "./cropImage";
import ImageDialog from "../ImageDialog/ImageDialog";
import Header from "../Header/Header";

import "./BuildBackground.css";

const images = [
  "/images/template/receive/r_bg_01.png",
  "/images/template/receive/r_bg_02.png",
  "/images/template/receive/r_bg_03.png",
  "/images/template/receive/r_bg_04.png",
  "/images/template/receive/r_bg_05.png",
  "/images/template/receive/r_bg_06.png",
  "/images/template/receive/r_bg_07.png",
  "/images/template/receive/r_bg_08.png",
  "/images/template/receive/r_bg_09.png",
  "/images/template/receive/r_bg_10.png",
];

const jpg_images = [
  "/images/template/receive/r_bg_01.jpg",
  "/images/template/receive/r_bg_02.jpg",
  "/images/template/receive/r_bg_03.jpg",
  "/images/template/receive/r_bg_04.jpg",
  "/images/template/receive/r_bg_05.jpg",
  "/images/template/receive/r_bg_06.jpg",
  "/images/template/receive/r_bg_07.jpg",
  "/images/template/receive/r_bg_08.jpg",
  "/images/template/receive/r_bg_09.jpg",
  "/images/template/receive/r_bg_10.jpg",
];

const mask_images = [
  "/images/template/mask/mask_01.png",
  "/images/template/mask/mask_02.png",
  "/images/template/mask/mask_03.png",
  "/images/template/mask/mask_04.png",
  "/images/template/mask/mask_05.png",
  "/images/template/mask/mask_06.png",
  "/images/template/mask/mask_07.png",
  "/images/template/mask/mask_08.png",
  "/images/template/mask/mask_09.png",
  "/images/template/mask/mask_10.png",
];

const masks = [
  `url(${require("./facemask/mask_01.png")})`,
  `url(${require("./facemask/mask_02.png")})`,
  `url(${require("./facemask/mask_03.png")})`,
  `url(${require("./facemask/mask_04.png")})`,
  `url(${require("./facemask/mask_05.png")})`,
  `url(${require("./facemask/mask_06.png")})`,
  `url(${require("./facemask/mask_07.png")})`,
  `url(${require("./facemask/mask_08.png")})`,
  `url(${require("./facemask/mask_09.png")})`,
  `url(${require("./facemask/mask_10.png")})`,
];

const locations = [
  { x: 193, y: 1041 },
  { x: 193, y: 1041 },
  { x: 193, y: 1041 },
  { x: 193, y: 1041 },
  { x: 193, y: 1041 },
  { x: 266, y: 1438 },
  { x: 266, y: 1438 },
  { x: 266, y: 1438 },
  { x: 266, y: 1438 },
  { x: 266, y: 1438 },
];

const text_locations = [
  { x: 200, y: 90 },
  { x: 200, y: 50 },
  { x: 200, y: 50 },
  { x: 220, y: 30 },
  { x: 200, y: 30 },
  { x: 200, y: 90 },
  { x: 200, y: 50 },
  { x: 200, y: 50 },
  { x: 220, y: 30 },
  { x: 200, y: 30 },
];

const sizes = [
  { width: 746, height: 746 },
  { width: 746, height: 746 },
  { width: 746, height: 746 },
  { width: 746, height: 746 },
  { width: 746, height: 746 },

  { width: 929, height: 929 },
  { width: 929, height: 929 },
  { width: 929, height: 929 },
  { width: 929, height: 929 },
  { width: 929, height: 929 },
];

async function uploadTaskPromise(path, file) {
  return new Promise(function (resolve, reject) {
    const storageRef = storage.ref(path);
    const uploadTask = storageRef.put(file);
    uploadTask.on(
      "state_changed",
      function (snapshot) {
        // var progress =
        //   (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        // console.log("Upload is " + progress + "% done");
      },
      function error(err) {
        console.log("error", err);
        reject();
      },
      function complete() {
        uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
          resolve(downloadURL);
        });
      }
    );
  });
}

const BuildMyBackground = () => {
  const { state, setImageFile, setProfileFile } = useContext(KitContext);
  let history = useHistory();
  const [faceIndex, setFaceIndex] = useState(0);
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [rotation, setRotation] = useState(0);
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [croppedImage, setCroppedImage] = useState(null);
  const [profileImage, setProfileImage] = useState(null);
  const [showCropDialog, setShowCropDialog] = useState(false);
  const [osText, setOsText] = useState("iOS용 배경화면 이미지");

  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };

  const showCroppedImage = useCallback(async () => {
    try {
      const cropped = await getCroppedImg(
        imageSrc,
        croppedAreaPixels,
        rotation,
        sizes[faceIndex]
      );

      // need to merge with face_mask when store it
      console.log(mask_images[faceIndex]);
      const profile = await mergeImages([
        cropped,
        mask_images[faceIndex],
        {
          src: "/images/template/text/profile_text_receive.png",
          x: text_locations[faceIndex].x,
          y: text_locations[faceIndex].y,
        },
      ]);
      setProfileImage(profile);

      // merge with template
      // need to check image size from camera and template
      const merge = await mergeImages([
        { src: cropped, x: locations[faceIndex].x, y: locations[faceIndex].y },
        images[faceIndex],
      ]);
      setCroppedImage(merge);
    } catch (e) {
      console.error(e);
    }
  }, [croppedAreaPixels, rotation]);

  const onClose = useCallback(() => {
    console.log("onClose");
    setProfileImage(null);
    setCroppedImage(null);
    setShowCropDialog(false);
  }, []);

  const onSave = async () => {
    let filename = "test.png";

    if (state.kitID !== "") {
      filename = state.kitID + ".png";
    }

    // upload profile image
    const profileBlob = await (await fetch(profileImage)).blob();
    const profileFile = new File([profileBlob], filename, {
      type: "image/png",
    });
    const profileURL = await uploadTaskPromise(
      `/profile/${filename}`,
      profileFile
    );
    setProfileFile(profileURL);

    // upload background image
    const blob = await (await fetch(croppedImage)).blob();
    const file = new File([blob], filename, { type: "image/png" });
    const URL = await uploadTaskPromise(`/images/${filename}`, file);
    setImageFile(URL);

    // Return to build_mykit
    history.push("/build_mykit");
  };

  const imageTemplate = (image) => {
    return (
      <div className="p-grid p-nogutter">
        <div className="p-col-12">
          <img
            src={image}
            alt=""
            width="100%"
            height="auto"
            style={{
              width: "55%",
              height: "auto",
              display: "block",
              margin: "auto",
              justifyContent: "center",
            }}
          />
        </div>
      </div>
    );
  };

  const handleImageCapture = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      // Resize
      Resizer.imageFileResizer(
        file,
        900,
        1600,
        "JPEG",
        90,
        0,
        (uri) => {
          setImageSrc(uri);
          setShowCropDialog(true);
        },
        "base64",
        720,
        1280
      );
    }
  };

  useEffect(() => {
    jpg_images.forEach((image) => {
      new Image().src = image;
    });

    masks.forEach((image) => {
      new Image().src = image;
    });
  }, []);

  return (
    <div>
      <Header title="배경화면 만들기" />
      <div>
        <Dialog
          style={{ height: "90%", width: "90%" }}
          visible={showCropDialog}
          blockScroll={true}
          showHeader={false}
          position="center"
          modal={true}
          onHide={() => {
            setShowCropDialog(false);
          }}
        >
          <div>
            <Cropper
              image={imageSrc}
              crop={crop}
              rotation={rotation}
              zoom={zoom}
              minZoom={0.5}
              maxZoom={3}
              aspect={746 / 746}
              showGrid={false}
              onCropChange={setCrop}
              onRotationChange={setRotation}
              onCropComplete={onCropComplete}
              onZoomChange={setZoom}
              restrictPosition={false}
              style={{
                cropAreaStyle: {
                  "background-repeat": "no-repeat",
                  "background-size": "cover",
                  backgroundImage: masks[faceIndex],
                },
              }}
            />
            <div className="p-grid">
              <div className="p-col-6">
                <Button
                  label=" "
                  className="p-text-plain p-button-text"
                  onClick={() => {
                    setShowCropDialog(false);
                  }}
                  style={{ width: "200px", height: "80px" }}
                >
                  <img
                    src="/images/cancel_button.png"
                    alt=""
                    width="auto"
                    height="60px"
                  />
                </Button>
              </div>
              <div className="p-col-6">
                <Button
                  label=" "
                  className="p-text-plain p-button-text"
                  onClick={() => {
                    // overlayRef.current.hide(overlayRef);
                    setShowCropDialog(false);
                    showCroppedImage();
                  }}
                  style={{ width: "200px", height: "80px" }}
                >
                  <img
                    src="/images/ok_button.png"
                    alt=""
                    width="auto"
                    height="60px"
                  />
                </Button>
              </div>
            </div>
          </div>
          <div className="p-grid">
            <div className="p-col-12">
              <div style={{ position: "fixed", bottom: 0, color: "white" }}>
                사진을 터치하여 얼굴을 윤곽에 맞춰주세요.
              </div>
            </div>
          </div>
        </Dialog>
      </div>
      <div>
        <div className="p-grid">
          <div className="p-col-6">{osText}</div>
        </div>
        <div className="p-grid">
          <div className="p-col-12">
            <Galleria
              value={jpg_images}
              activeIndex={faceIndex}
              numVisible={1}
              style={{ width: "auto", height: "50%" }}
              showItemNavigators
              showIndicators
              showThumbnails={false}
              circular={true}
              item={imageTemplate}
              onItemChange={(e) => {
                setFaceIndex(e.index);
                if (e.index >= 5) {
                  setOsText("안드로이드용 배경화면 이미지");
                } else {
                  setOsText("iOS용 배경화면 이미지");
                }
              }}
            />
          </div>
          <div className="p-col-12">
            * 얼굴을 합성할 배경화면을 선택해 주세요.
          </div>
        </div>
        <div className="p-grid">
          <div className="p-col-12">
            <img
              src="/images/capture_button.png"
              alt=""
              height="80px"
              width="auto"
              onClick={() => {
                document.getElementById("camera").click();
              }}
            />
            <input
              type="file"
              id="camera"
              accept="image/*"
              capture="user"
              style={{ display: "none" }}
              onChange={handleImageCapture}
            />
          </div>
        </div>
      </div>
      <ImageDialog img={croppedImage} onClose={onClose} onSave={onSave} />
    </div>
  );
};

export default BuildMyBackground;
